export default {"src":"/_next/static/media/BND.f2176781.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};